import Store from './store'
let softDataStatus // softDataStatus 为enable 或者 none 时, 页面可编辑. 否则页面不可编辑. 数据正在上链
const commonWidgets = [
	'text/plain',
	'text/multiline',
	'text/integer',
	'text/float',
	'text/boolean',
	'other/enum',
	'media/video',
	'media/image',
	'media/file',
	'media/audio',
	'text/date',
	'text/datetime'
]

const presetWidgets = {
	100001: 'datainfolist',
	100002: 'gps',
	100003: 'media/audio',
	100004: 'media/file',
	100005: 'media/image',
	100006: 'media/video',
	100007: 'vidlist',
	100012: 'basedatainfolist'
}

const lang = window.navigator.language.indexOf('zh') > -1 ? 'zh-CN' : 'en-US' // 浏览器语言
let currentLangulage = {} // 当前datamodel语言包
let baseOrCustomLangulage = {} // 对应的base或者custom语言包

export default {
	/// init keys container
	initKeys (items, obj) {
		items.forEach(item => {
			console.log("item_begin", item)
			if (item.contentType == 'other/list') {
				obj[item.key] = []
			} else if (item.contentType && item.contentType.indexOf('datamodel') > -1) {
				obj[item.key] = {}
			} else {
				obj[item.key] = ''
			}
			console.log("item_end", item)
		})
		return obj
	},
	generateFormRule(data) {

		// note: 后面可能会加validateFunction
		let result = []
		let type = data.contentType
		if (type === 'text/plain' || type === 'text/multiline') {
			// max_valid
			result.push({max: data.max, message: window.MPApp.$t('app.required', {max: data.max}), trigger: 'blur'})
		}
		console.log("type", type)
		if (type && type !== 'other/list' && type.indexOf('datamodel/') < 0) {
			result.push({required: data.required, message: window.MPApp.$t('app.required'), trigger: 'change'})
		}
		return result
	},
	/// data form transfer to widget
	transfer(data, form, widget) {
		softDataStatus = Store.getters.getSoftDataStatus
		if (JSON.stringify(currentLangulage) == "{}") {
			const LangulagesArray = Store.state.languagePackage // 语言包
			LangulagesArray.forEach(language => {
				if (data.uuid && language.uuid.substring(30).replace('28', '20') === data.uuid.substring(30)) {
					currentLangulage = language.language
					return
				}
			})
		}
		if (Array.isArray(data)) {
			data.forEach((item, index) => {
				let datamodel = searchReference(item)
				console.log("data_model",datamodel)
				if (Array.isArray(form)) {
					form[0][item.key] = ''
					widget[index] = {}
					Object.assign(widget[index],
						datamodel,
						item.dataReference,
						item.controlReference,
						item.displayReference,
						{ name: item.key, prop: item.key, uuid: guid() })
					if (softDataStatus === 'disable') widget[index].editable = false
					return this.transfer(datamodel, form[0][item.key], widget[index])
				} else {
					console.log("datamodel_contentType_begin", datamodel.contentType)
					if (datamodel.contentType === 'other/list' || datamodel.contentType === 'otherlist') {
						form[item.key] = [{}]
						if (item.dataReference.itemType) {
							datamodel.itemType = item.dataReference.itemType
						}
					} else if (datamodel.contentType === 'other/object' || datamodel.contentType === 'otherobject') {
						form[item.key] = {}
						if (item.dataReference.attributes) {
							datamodel.attributes = item.dataReference.attributes
						}else{
							Object.assign(datamodel, { ...item.dataReference })
						}
					} else if (datamodel.contentType == undefined) {
						console.log("empty_content_type_datamodel", datamodel)
						console.log("item", JSON.stringify(item))
						form[item.key] = ''
					} else if ((datamodel.contentType != undefined && datamodel.contentType.indexOf('model') > -1) || datamodel.contentType === 'gps' || datamodel.contentType.indexOf('media') > -1) {
						form[item.key] = {}
					} else {
						form[item.key] = ''
					}
					console.log("datamodel_contentType_end", datamodel.contentType)
					widget[index] = {}
					if (datamodel.contentType && (datamodel.contentType.indexOf('basemodel') > -1 || datamodel.contentType.indexOf('custommodel') > -1)) {
						/// add reference
						Object.assign(datamodel, { ...item.dataReference })
						const type = datamodel.contentType.replace('model', '')
						if (currentLangulage[lang]) baseOrCustomLangulage = currentLangulage[lang][type]
					}

					console.log("datamodel__", JSON.stringify(datamodel))
					console.log("refres", JSON.stringify(item.dataReference))
					Object.assign(widget[index],
						item.dataReference,
						item.controlReference,
						item.displayReference,
						{ contentType: datamodel.contentType, name: item.key, prop: item.key },
						baseOrCustomLangulage[item.key],
						{ uuid: guid() })
					if (softDataStatus === 'disable') widget[index].editable = false

					console.log("widget[index]", JSON.stringify(widget[index]))
					return this.transfer(datamodel, form[item.key], widget[index])
				}
			})
		} else if (data.attributes) {
			console.log("data_attributes",data)
			widget.content = new Array(data.attributes.length)
			return this.transfer(data.attributes, form, widget.content)
		} else if (data.itemType) {
			let item = searchReference(data)
			console.log("item.contentType", item)
			var itemIsValid = item.contentType && Object.keys(item.contentType).length > 0
			if (data.contentType === 'other/list' && itemIsValid && commonWidgets.includes(item.contentType.toLowerCase())) {
				let copy = JSON.parse(JSON.stringify(item))
				delete copy['attributes']
				widget.content = [{
					...copy,
					...data.itemType.dataReference,
					...data.itemType.controlReference,
					...data.itemType.displayReference
				}]
				return this.transfer(item, form, widget.content[0])
			} else if (item.contentType === 'other/object') {

				if (data.itemType) {
					widget.content = new Array(data.itemType.dataReference.attributes.length)
					return this.transfer(data.itemType.dataReference.attributes, form, widget.content)
				} else {
					let copy = JSON.parse(JSON.stringify(item))
					let newItem = {
						...copy,
						...data.dataReference
					}
					widget = {}
					return this.transfer(newItem, form, widget)
				}
			}
			return this.transfer(item, form, widget)
		}
		return {form, widget}
	},

	dateFormat(str, fmt) {
		const date = new Date(str)
		const month = date.getMonth() + 1
		const day = date.getDate()
		const hours = date.getHours()
		const min = date.getMinutes()
		const second = date.getSeconds()
		const o = {
			'M+': month,
			'd+': day,
			'h+': hours,
			'm+': min,
			's+': second
		}
		if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length))
		for (let k in o) {
			if (new RegExp(`(${k})`).test(fmt)) {
				fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)))
			}
		}
		return fmt
	}
}

function guid() {
	function S4() {
		return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
	}
	return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}


function searchReference(item) {
	/// 已有contentType
	if (item.type && presetWidgets[item.type.substr(30)]) {
		return {
			contentType: presetWidgets[item.type.substr(30)]
		}
	} else {
		/// 
		const childModel = JSON.parse(Store.getters.getChildModel)
		let result = {}
		childModel.forEach(child => {
			if (item.itemType) {
				if (child.uuid === item.itemType.type) {
					return result = child
				}
			} else {
				if (child.uuid === item.type) {
					return result = child
				}
			}
		})
		return result
	}
}